// Data
import { getNameRegex } from '../user-management/supplier-details/data';
import { getCompanyNameRegex } from '../view-profile/pickup-address/capture-pickup-address/data';
import { regex } from '../../validator/isDataType';

export const uspLandingMenu = [
  {
    id: '1',
    header: 'About Us',
    hasSubMenu: false
  },
  {
    id: '2',
    header: 'USP Features',
    hasSubMenu: false
  },
  {
    id: '3',
    header: 'Our Ecosystem',
    hasSubMenu: false
  },
  {
    id: '4',
    header: 'Contact Us',
    hasSubMenu: false
  }
];

export const getInTouchDynamicFormFields = [
  {
    type: 'TEXT',
    id: 'name',
    name: 'name',
    displayName: 'Name',
    value: '',
    validation: {
      rule: {
        required: {
          isRequired: true
        },
        regex: {
          pattern: getNameRegex()
        }
      }
    },
    error: '',
    fullWidth: false
  },
  {
    type: 'TEXT',
    id: 'organization',
    name: 'organization',
    displayName: 'Organization',
    value: '',
    validation: {
      rule: {
        required: {
          isRequired: true
        },
        regex: {
          pattern: getCompanyNameRegex()
        }
      }
    },
    error: '',
    fullWidth: false
  },
  {
    type: 'TEXT',
    id: 'email',
    name: 'email',
    displayName: 'Work email',
    value: '',
    validation: {
      rule: {
        required: {
          isRequired: true
        },
        email: {
          isEmail: true
        },
        regex: {
          pattern: regex.email
        }
      }
    },
    error: '',
    fullWidth: false
  },
  {
    type: 'COMBINE',
    id: 'phone-combine',
    name: 'phone-combine',
    className: 'phone__isd__combine-field',
    hidden: false,
    attributes: [
      {
        type: 'SINGLE_SELECT_WITH_SEARCH',
        id: 'isdCode',
        name: 'isdCode',
        displayName: 'Code',
        value: '',
        validation: {
          rule: {
            required: {
              isRequired: false
            }
          }
        },
        error: '',
        fullWidth: false,
        options: []
      },
      {
        type: 'TEXT',
        id: 'phoneNumber',
        name: 'phoneNumber',
        displayName: 'Phone Number',
        value: '',
        validation: {
          rule: {
            required: {
              isRequired: false
            },
            regex: {
              pattern: regex.telephone
            }
          }
        },
        error: '',
        fullWidth: false
      }
    ]
  },
  {
    type: 'TEXTAREA',
    id: 'description',
    displayName: 'Please briefly describe the support you are looking with us',
    name: 'description',
    placeHolder: 'Write your message here.',
    value: '',
    fullWidth: true,
    validation: {
      rule: {
        required: { isRequired: false },
        length: {
          max: 250
        }
      }
    }
  }
];
